import axios from 'axios';

export function getTeacherUrl(bookingId) {
  return axios.get(`/api/lesson/${bookingId}/get-url?for=teacher`);
}

export function getStudentUrl(bookingId) {
  return axios.get(`/api/lesson/${bookingId}/get-url?for=student`);
}

export function getLesson(lessonId) {
  return axios.get(`/api/lessons/${lessonId}`);
}

export function getLessonByBookingId(id) {
  return axios.get(`/api/lesson/${id}`);
}
